<template>
  <my-dialog
    :title="title"
    :visible.sync="t_dialog_show"
    :show-close="true"
    :has-width="false"
    :close-on-click-modal="false"
    :append-to-body="appendToBody"
    :modal-append-to-body="modalAppendToBody"
    class="dialog-div"
    @MyDialogClose="dialogClose"
  >
    <div
      v-loading.lock="confirmLoading"
      class="fkdialog"
    >
      <div class="dialog_left">
        <div class="left_top">
          <span>{{ t('筛选条件') }}</span>
          <span>
            <i
              v-if="!open_close_icon"
              class="iconfont"
              @click="nodeOpen"
            >&#xe61a;</i>
            <i
              v-if="open_close_icon"
              class="iconfont"
              @click="nodeCLose"
            >&#xe62c;</i>
            <i
              class="iconfont"
              @click="clearNode"
            >&#xe61d;</i>
          </span>
        </div>
        <div
          id="left_scroll_center"
          class="left_center"
        >
          <tree
            v-loading.lock="tree_loading"
            :tree_lists="tree_lists"
            class="left-tree"
            @tree_change="tree_change"
          />
        </div>
        <!--<div class="left_bottom">
                <el-button @click="addCondition">{{t('添加条件')}}</el-button>
            </div>-->
      </div>
      <div
        class="dialog_center"
        :class="{'second-width': activeName === 'second' }"
      >
        <el-tabs v-model="activeName">
          <el-tab-pane
            :label="t('筛选结果')"
            name="first"
            class="el-tab-auto"
          >
            <el-pagination
              :current-page="l_center_data.l_currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="l_center_data.l_page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="l_center_data.total"
              @size-change="l_handleSizeChange"
              @current-change="l_handleCurrentChange"
            />
            <show-table-data
              ref="screen_ck"
              v-loading.lock="l_screenLoading"
              :table_head="l_table_data.header"
              :table_data="l_table_data.body[l_center_data.l_currentPage-1]"
              :table_checked="l_table_data.checked[l_center_data.l_currentPage-1]"
              :current-page="l_center_data.l_currentPage-1"
              :size-page="l_center_data.l_page_size"
              id_name="first"
              @center_change="center_change"
              @single="single"
            />
          </el-tab-pane>
          <el-tab-pane
            :label="t('查看选中结果')"
            name="second"
            class="el-tab-auto"
          >
            <el-pagination
              :current-page="r_center_data.r_currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="r_center_data.r_page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="r_center_data.total"
              @size-change="r_handleSizeChange"
              @current-change="r_handleCurrentChange"
            />
            <show-table-data
              ref="result_ck"
              :table_head="r_table_data.header"
              :table_data="r_table_data.body[r_center_data.r_currentPage-1]"
              :current-page="r_center_data.r_currentPage-1"
              :size-page="r_center_data.r_page_size"
              :table_checked="r_table_data.checked[r_center_data.r_currentPage-1]"
              id_name="second"
              @center_change="center_change"
            />
          </el-tab-pane>
        </el-tabs>
        <div
          v-if="activeName === 'first' "
          class="center_bottom"
        >
          <el-input
            ref="searchWord"
            v-model="searchWord"
            @keyup.enter.native="keyupWord"
            @change="searchWordChange"
          >
            <i
              slot="suffix"
              class="el-icon-search el-input__icon"
              @click="onIconClick"
            />
            <template slot="prepend">
              {{ t('全局检索') }}
            </template>
          </el-input>
          <div class="center-exclude">
            <label for="exclude">
              <input
                id="exclude"
                v-model="exclude"
                type="checkbox"
                name=""
                value=""
              >
              <span class="checked-box" />
              <span> {{ t('排除') }}</span>
            </label>
          </div>
        </div>
        <div
          v-if="activeName !== 'first' "
          class="center_bottom center-b-t"
        >
          <!--<i class="el-input__icon el-icon-search is-clickable center-icon" @click="onSearchResult"></i>
          <el-autocomplete
            v-model="searchResult"
            :fetch-suggestions="querySearchAsync"
            @select="handleSelect"
            @keyup.enter.native="keyupSearch"
            :trigger-on-focus="trigger_focus"
            ref="trigger_searchResult"
          >
            <div slot="prepend">查询结果</div>
            &lt;!&ndash;<i
              class="el-icon-search el-input__icon"
              @click="onSearchResult"
              slot="append"
            >
            </i>&ndash;&gt;
            &lt;!&ndash;<template slot-scope="props">
              <div class="name">{{ props.item.value }}</div>
              <span class="addr">{{ props.item.address }}</span>
            </template>&ndash;&gt;
          </el-autocomplete>-->
          <el-input
            ref="searchResult"
            v-model="searchResult"
            @keyup.enter.native="keyupSearch"
            @change="searchResultChange"
          >
            <i
              slot="suffix"
              class="el-icon-search el-input__icon"
              @click="onSearchResult"
            />
            <template slot="prepend">
              {{t('查询结果')}}
            </template>
          </el-input>
        </div>
      </div>
      <div
        v-if="activeName === 'first' "
        class="dialog-operation"
      >
        <div
          class="operation-more operation-icon iconfont operation-hover"
          @click="addCondition"
        >
          &#xe606;
        </div>
        <div
          class="operation-single iconfont operation-icon operation-hover"
          @click="center_change(single_data)"
        >
          &#xe613;
        </div>
      </div>
      <!--<div class="dialog-operation" v-if="activeName !== 'first' ">
        <div class="operation-more operation-icon iconfont icon-bc">&#xe606;</div>
        <div class="operation-single iconfont operation-icon icon-bc">&#xe613;</div>
      </div>-->
      <div class="dialog_right">
        <div class="right_top">
          <span>{{ t('已选中') }}</span><span>(</span><span>{{ r_center_data.rightTotal }}</span><span>)</span>

          <span>
            <i
              class="iconfont"
              @click="showOrHidden=true"
            >&#xe61c;</i>
            <i
              class="iconfont"
              @click="clearAllResult"
            >&#xe61e;</i>
          </span>
        </div>
        <div class="right_center">
          <ul>
            <li
              v-for="(item, index) in r_result"
              :key="index"
            >
              <p>{{ item.exclude? `${t('排除')}：` : '' }}{{ item.screen_string }}</p>
              <i
                class="iconfont icon-fork"
                @click="deleteList(index)"
              />
            </li>
          </ul>
        </div>
        <div class="right_bottom">
          <el-button @click="dialogClose">
            {{ t('取消') }}
          </el-button>
          <el-button @click="dialogConfirm">
            {{ t('确认') }}
          </el-button>
        </div>
      </div>
      <div
        v-if="showOrHidden"
        class="modalDiv"
      >
        <div class="modalCenter">
          <div class="modalTitle">
            <span class="modalText">{{ t('保存为模板') }}</span>
            <i
              class="iconfont icon-cha1"
              @click="showOrHidden = !showOrHidden"
            />
          </div>
          <div class="modalContent">
            <!--<svg class="query-icon muBan" aria-hidden="true">
              <use xlink:href="#icon-moban"></use>
            </svg>-->
            <i class="iconfont muBan">&#xe637;</i>
            <div class="textCenter">
              {{ t('模板名称') }}：<input
                v-model="module_name"
                type="text"
              >
            </div>
            <div class="modalBtn">
              <button
                class="btn"
                @click="result_save"
              >
                <span>{{ t('确认') }}</span>
              </button>
              <button
                class="btn"
                @click="showOrHidden = !showOrHidden"
              >
                <span>{{ t('取消') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="errorDialog"
      class="fk-error-dialog"
    >
      <div class="fk-error-dialog-box">
        <div class="fk-error-dialog-title">
          {{t('警告')}}
          <span class="fk-error-icon">
            <i
              class="iconfont icon-cha1"
              @click="errorDialog = false"
            />
          </span>
        </div>
        <div class="fk-error-dialog-body">
          <div class="fk-body-top">
            <div class="fk-body-top-left">
              <i class="iconfont">&#xe631;</i>
            </div>
            <div class="fk-body-top-right">
              <p v-for="(list, index) in errorData">
                {{ list.message }}
              </p>
            </div>
          </div>
          <div class="fk-body-bottom">
            <el-button @click="errorDialogClose">
              {{t('确认')}}
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <!--<drag-dialog
      v-if="errorDialog"
      :title="errorDialogTitle"
      size="mini"
      :append-to-body="true"
      :modal-append-to-body="true"
      :visible.sync="errorDialog"
      :close-on-click-modal="false"
      :showClose="true"
      :DialogClass="errorDialogClass"
      :class="warnDialogClass"
    >
      <errorMessage :errorMessage="errorData" :DialogBack="errorDialogBack" :DialogClass="warnDialogClass"
                    v-on:refreshbizlines="errorDialogClose"></errorMessage>
    </drag-dialog>-->
  </my-dialog>
</template>

<script> /* type="ecmascript-6" */
  import MyDialog from '../dialog/mydialog.vue';
  import DragDialog from '../dialog/mydialog.vue';
  import tree from './tree.vue';
  import axios from '../../__utils__/request';
  import ShowTableData from '../views/custompage/ShowTableData.vue';
  // ../../views/custompage/ShowTableData.vue
  import errorMessage from './error.vue';

  export default {
    name: 'fkdialog',
    props: {
      tablename: {
        type: String
      }, // 表名
      tableid: [String, Number], // 表id
      rightList: [Object, String],
      modalAppendToBody: {
        type: Boolean,
        default: true
      }, // 將蒙层放在body上
      appendToBody: {
        type: Boolean,
        default: false
      }, // 是否将弹框放在body
      fkshow: {
        type: Boolean,
        default: true
      }, // 显示
      isObject: {
        type: Boolean,
        default: false
      }, // 判断是否是单对象
      title: {
        type: String,
        default: function() {
          return t('弹框多选')
        }
      }, // 标题
      canChinese: {
        type: Boolean,
        default: true
      }, // 是否可以模糊搜索中文
      isOneData: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        confirmLoading: false, // 页面loading
        t_dialog_show: true, // 弹框显示
        activeName: 'first', // tab名
        table_name: 'PS_C_PRO', // 测试表名
        trigger_focus: false,
        open_close_icon: false, // 筛选结果展开收拢
        code_name: '', // 配置项
        /* 以上公共部分 */

        errorDialog: false, // errorDialog
        errorDialogClass: 'error', // 弹框类型
        warnDialogClass: 'warning',
        errorDialogTitle: t('错误'), // 弹框标题
        errorData: [{ message: '' }], // 弹框内容
        errorDialogBack: false, // 是否有返回按钮
        /* 弹框部分 */

        tree_loading: false, // 节点树loading
        l_screen_result_save: {}, // 左边刷选结果保存
        tree_lists: [], // 左边列表树
        isTreeOrSearch: true, // 判断点的是左边树还是搜索的
        /* 以上左边树数据 */

        l_center_data: {
          l_currentPage: 1, // 当前页
          l_page_size: 50, // 页面显示个数
          total: 0, // 总个数
        }, // 筛选结果分页组件数据
        l_table_data: {
          header: {},
          body: [],
          checked: [],
        }, // 左边筛选结果table数据
        l_screenLoading: false, // loading
        searchWord: '', // 筛选结果检索
        exclude: false, // 排除选项
        /* 以上筛选结果数据 */

        r_result: [], // 右边数据渲染列表
        /* r_send_result: [
        {
          CONDITION: {},
          ID: []
        }
      ],//有筛选条件的排序项 */
        /* r_condition: [],//保存筛选结果同条件下的排除选项
      r_null_obj: {
        condition: {},
        ID: []
      },//保存没有筛选条件下的排除项 */
        /* r_result_checked: [],//保存筛选项 */
        request_param: {}, // 保存模板用的数据
        /* light_sub: -1,//高亮下标 */
        optimize_request: {}, // 优化请求用的
        r_result_length: -1, // 用于请求优化
        /* 以上右边列表数据 */

        r_screenLoading: false, // loading
        single_data: [], // 保存筛选结果的高亮项
        searchResult: '', // 选中结果全局检索
        r_center_data: {
          r_currentPage: 1, // 当前页
          r_page_size: 50, // 页面显示个数
          total: 0, // 总个数
          rightTotal: 0, // 右边条件查询的总数
        },
        r_table_data: {
          header: {},
          body: [],
          checked: [],
        }, // 右边筛选结果table数据
        /* restaurants: [],//模糊搜索的数据 */
        /* 以上选中结果数据 */

        showOrHidden: false, // 模态框的显示
        module_name: '', // 模板名
      /* 以上模板框数据 */
      };
    },
    components: {
      tree,
      ShowTableData,
      MyDialog,
      errorMessage,
      DragDialog
    },
    methods: {
      MyDialogClose() {
        this.$emit('dialogClose');
      }, // 关闭弹框向上派发事件
      nodeOpen() {
        const list = $('.dislogtree .node');
        const arr = this.tree_lists.map((obj) => {
          obj.show = true;
          return Object.assign({}, obj);
        });
        this.$set(this, 'tree_lists', arr);
        this.$nextTick(() => {
          list.each((index, item) => {
            $(item).find('.title i').css('transform', 'rotate(90deg)');
            $(item).find('ul').slideDown();
          });
          this.open_close_icon = true;
        });
      }, // 左边节点树打开
      nodeCLose() {
        const _self = this;
        const list = $('.dislogtree .node');
        list.each((index, item) => {
          $(item).find('.title i').css('transform', 'rotate(0deg)');
          $(item).find('ul').slideUp();
        });
        this.open_close_icon = false;
      }, // 左边节点树关闭
      clearNode() {
        this.isTreeOrSearch = true;// 表示不是搜索的
        //        this.searchWord = '';//清空搜索
        this.l_table_data.body = [];// 清空table数据
        this.l_center_data.l_currentPage = 1;// 页码重置
        this.l_screen_result_save = {};// 清空保存的选中的
        this.$refs.screen_ck.val_arr = [];// 清空子组件选中的
        this.$refs.screen_ck.l_sub = [];// 清空高亮
        this.single_data = [];// 清空父组件选中的
        this.tree_lists = this.tree_lists.map((obj, index) => {
          obj.checked = [];
          obj.VALUE.forEach((n) => {
            n.ischecked = false;
          });
          return obj;
        });// 清空选中的
        this.screen_request();// 从新获取数据
      }, // 清空左边选中项并重新获取数据
      tree_change(val) {
        const screen = {};
        this.isTreeOrSearch = true;// 表示不是搜索的
        //        this.searchWord = '';//清空搜索
        /* console.log(val) */
        this.l_table_data.body = [];// 清空数据
        /* this.l_table_data.checked = [];//清空数据 */
        this.l_center_data.l_currentPage = 1;// 页码重置
        /* if (!this.exclude) {//不排除选中项 */
        val.map((obj) => {
          if (obj.checked.length === 0) return;// 没有选中项
          screen[obj.AKNAME] = obj.checked;
        });
        /* }else {//排除选中项
        val.map((obj) => {
          let checked_obj = obj;
          if(checked_obj.checked.length === 0) return; //没有选中项
          screen[obj['AKNAME']] = [];
          checked_obj['VALUE'].map((n_obj) => {
            let judge=checked_obj.checked.findIndex((n) => n_obj.ID === n );//查找列表中选中对象的下标
            if( judge === -1) {//选出没勾选的
              screen[checked_obj['AKNAME']].push(n_obj.ID);
            }
          })
        })
      } */
        this.l_screen_result_save = screen;// 保存筛选结果
        /* if(Object.keys(screen).length !== 0){
        this.r_send_result.push({
          CONDITION: screen,//筛选条件
          ID: []//排除ID集合
        })//每次条件变化添加一个条件
      } */
        this.$refs.screen_ck.val_arr = [];// 清空子组件选中的
        this.$refs.screen_ck.l_sub = [];// 清空高亮
        this.single_data = [];// 清空父组件选中的
        this.screen_request();// 获取筛选结果数据
      }, // 左边列表勾选变化时
      screen_request() {
        this.l_screenLoading = true;
        axios({
          url: '/p/cs/screenresult',
          method: 'post',
          data: {
            param: JSON.stringify({
              TABLENAME: this.tablename, // 表名
              CONDITION: this.l_screen_result_save, // 左边选中的列表
              GLOBAL: this.isTreeOrSearch ? '' : this.searchWord.trim(), // 全局搜索值
              PAGENUM: this.l_center_data.l_currentPage, // 当前页
              PAGESIZE: this.l_center_data.l_page_size, // 每页显示个数
            })
          }
        }).then((res) => {
          const response = res.data;
          if (response.code !== 0) {
            /* this.errorDialogClass = 'error';
          this.errorData = [{message: response.message}];
          this.errorDialog = true; */
            return;
          }
          this.l_screenLoading = false;
          this.$nextTick(() => {
            this.code_name = response.akname.split(',');
            this.l_center_data.total = response.data.total; // 筛选结果总数
            this.l_table_data.header = JSON.parse(response.header);// 头部信息
            this.l_table_data.body[this.l_center_data.l_currentPage - 1] = response.data.list; // body信息
          });
        /* this.l_table_data.checked[this.l_center_data.l_currentPage-1] = [];//选中的选项 */
        });
      }, // 左边列表勾选变化获取数据
      screen_request_initialize() {
        this.l_screenLoading = true;
        return axios({
          url: '/p/cs/screenresult',
          method: 'post',
          data: {
            param: JSON.stringify({
              TABLENAME: this.tablename, // 表名
              CONDITION: this.l_screen_result_save, // 左边选中的列表
              GLOBAL: this.searchWord.trim(), // 全局搜索值
              PAGENUM: this.l_center_data.l_currentPage, // 当前页
              PAGESIZE: this.l_center_data.l_page_size, // 每页显示个数
            })
          }
        }).then((res) => {
          const response = res.data;
          if (response.code !== 0) {
            /* this.errorDialogClass = 'error';
          this.errorData = [{message: response.message}];
          this.errorDialog = true; */
            return;
          }
          this.l_screenLoading = false;
          this.$nextTick(() => {
            this.code_name = response.akname.split(',');
            this.l_center_data.total = response.data.total; // 筛选结果总数
            this.l_table_data.header = JSON.parse(response.header);// 头部信息
            this.l_table_data.body[this.l_center_data.l_currentPage - 1] = response.data.list; // body信息
          /* console.log(new Date().getTime()) */
          });
        /* this.l_table_data.checked[this.l_center_data.l_currentPage-1] = [];//选中的选项 */
        });
      }, // 初始化
      addCondition() {
        /* let _self = this
      _self.resultObj.idArr = []
      _self.resultObj.descArr = []
      let list = $('.dislogtree input[type=checkbox]:checked')
      list.each((index, item) => {
        let id = $(item).attr('data-id')
        let desc = $(item).next().text()
        _self.resultObj.idArr.push(id),
        _self.resultObj.descArr.push(desc)
      })

      let obj = _self.reaptData(_self.resultObj)
      _self.AllResult.push(obj)
      $('.dislogtree input[type=checkbox]').prop('checked',false) */
        // if(this.isTreeOrSearch){//表示不是搜索
        // 添加节点的
        const screen = {};
        const id_list = [];
        const screen_string = [];// 筛选显示字段
        let unmber = false;
        this.tree_lists.map((obj, index) => {
          const checked_obj = obj;
          if (checked_obj.checked.length === 0) return; // 父节点下面没有勾选的直接return
          const not_checked_s = [];
          screen[obj.AKNAME] = [];
          checked_obj.VALUE.map((n_obj) => { // 循环子列表
            const judge = checked_obj.checked.findIndex(n => n_obj.ID === n);// 查找列表中选中对象的下标
            /* if(judge === -1 && this.exclude || judge !== -1 && !this.exclude) {//没找到选中的并且是排除选项是true;找到了选中的并且排除选项是false
            screen[checked_obj['AKNAME']].push(n_obj.ID);
            not_checked_s.push(n_obj.NAME);
            unmber = true;
          } */
            if (judge !== -1) { // 右边只显示(排除或不排除)勾选的项
              screen[checked_obj.AKNAME].push(n_obj.ID);// 放入相应表数组中
              not_checked_s.push(n_obj.NAME);// 加入名字集合
              id_list.push(n_obj.ID);// 所有id集合
              unmber = true;
            }
          /* if( judge === -1 && this.exclude) {//选出没勾选的和排除勾选项
            screen[checked_obj['AKNAME']].push(n_obj.ID);
            not_checked_s.push(n_obj.NAME);
          }else if ( judge !== -1 && !this.exclude) {//不排除勾选项
            screen[checked_obj['AKNAME']].push(n_obj.ID);
            not_checked_s.push(n_obj.NAME);
          } */
          });
          /* console.log(screen_string += not_checked_s.join()); */
          screen_string.push(not_checked_s.join());// 拼接字段
        });
        if (!unmber) return; // 没选return
        this.r_result.unshift({// 向数组的头部添加
          screen_string: screen_string.join(' / '), // 筛选条件拼接
          screen, // 各个主节点下的子节点勾选
          exclude: this.exclude, // 判断是否排除勾选项
          id_list, // ID集合
        /* ID: this.r_result.length + '_choose', */
        });// 把筛选的值放入渲染数组
        //        }else {
        //          //添加搜索的
        //        }
        /* this.r_result_checked.push(this.r_result.length-1 + '_choose'); */
        /* 1、每次添加完是否要清楚数据 */
        this.clearNode();
        this.right_request_center();
      }, // 点击添加条件并清空选中项，不重新获取数据
      /* 以上左边树的所有相关事件 */

      single(val) {
        this.single_data = val;
      }, // 单击保存子组件传过来的数据
      l_handleCurrentChange(val) {
        this.l_center_data.l_currentPage = val;// 页码重置
        if (this.l_table_data.body[this.l_center_data.l_currentPage - 1]) return;// 已存在数据就不用获取了
        this.screen_request();
      }, // 当前页变化
      l_handleSizeChange(val) {
        this.l_table_data.body = [];// 清空table数据
        this.$refs.screen_ck.val_arr = [];// 清空子组件选中的
        this.$refs.screen_ck.l_sub = [];// 清空高亮
        this.single_data = [];// 清空父组件选中的
        /* this.l_table_data.checked = [];//清空checked数据 */
        this.l_center_data.l_page_size = val;// 改变每页显示个数
        this.l_center_data.l_currentPage = 1;// 页码重置
        this.screen_request();
      }, // 页数变化
      onIconClick() {
        const _this = this;
        this.isTreeOrSearch = false;// 表示是搜索的
        this.l_table_data.body = [];// 清空table数据
        this.l_center_data.l_currentPage = 1;// 页码重置
        this.l_screen_result_save = {};// 清空保存的选中的
        this.$refs.screen_ck.val_arr = [];// 清空子组件选中的
        this.$refs.screen_ck.l_sub = [];// 清空高亮
        this.single_data = [];// 清空父组件选中的
        this.tree_lists = this.tree_lists.map((obj, index) => {
          obj.checked = [];
          return obj;
        });// 清空选中的
        this.l_screenLoading = true;
        axios({
          url: '/p/cs/screenresult',
          method: 'post',
          data: {
            param: JSON.stringify({
              TABLENAME: this.tablename, // 表名
              CONDITION: this.l_screen_result_save, // 左边选中的列表
              GLOBAL: this.searchWord.trim(), // 全局搜索值
              PAGENUM: this.l_center_data.l_currentPage, // 当前页
              PAGESIZE: this.l_center_data.l_page_size, // 每页显示个数
            })
          }
        }).then((res) => {
          const response = res.data;
          if (response.code !== 0) {
            /* this.errorDialogClass = 'error';
          this.errorData = [{message: response.message}];
          this.errorDialog = true; */
            return;
          }
          this.l_screenLoading = false;
          let r_data_length = false;
          this.$nextTick(() => {
            this.l_center_data.total = response.data.total; // 筛选结果总数
            this.l_table_data.header = JSON.parse(response.header);// 头部信息
            this.l_table_data.body[this.l_center_data.l_currentPage - 1] = response.data.list; // body信息
            response.data.list.map((obj) => {
              let judgeTerm = false;// 用来判断搜索字段与查询到的数据相匹配
              this.code_name.map((codeName) => {
                if (obj[codeName].toLowerCase() === _this.searchWord.trim().toLowerCase()) judgeTerm = true;
              });
              if (judgeTerm) {
                const index = _this.r_result.findIndex(n => obj.ID === n.screen && _this.exclude === n.exclude);// 找到相同项
                if (index === -1) { // 没找到在添加
                  _this.r_result.unshift({
                    screen_string: obj[this.code_name[0]], // 商品款号
                    screen: obj.ID, // 商品ID
                    exclude: this.exclude, // 判断是否排除勾选项
                    id_list: [obj.ID], // ID集合
                  /* CONDITION: Object.keys(_this.l_screen_result_save).length === 0? 0 : _this.r_send_result.length - 1 //表示是有筛选条件的下标 */
                  /* ID: this.r_result.length + '_choose',//ID
                  checked: true,//是否勾选 */
                  });// 把筛选的值放入数组
                }
                r_data_length = true;// 表示有完全一样的
              }
            });
            if (r_data_length) {
              _this.right_request_center();// 重新获取数据
            }
          });
        /* this.l_table_data.checked[this.l_center_data.l_currentPage-1] = [];//选中的选项 */
        });
      }, // 筛选结果全局检索 图标点击
      keyupWord() {
        this.onIconClick();
      }, // enter快捷
      /* 以上筛选结果的相关事件 */
      searchWordChange(a) {
        let str = '';
        if (this.canChinese) {
          str = a.match(/[A-Za-z0-9\u4e00-\u9fa5]*/g);
        } else {
          str = a.match(/[A-Za-z0-9]*/g);
        }
        this.$refs.searchWord.currentValue = str[0];
        this.searchWord = str[0];
      }, // 搜索全局检索限制
      searchResultChange(a) {
        let str = '';
        if (this.canChinese) {
          str = a.match(/[A-Za-z0-9\u4e00-\u9fa5]*/g);
        } else {
          str = a.match(/[A-Za-z0-9]*/g);
        }
        this.$refs.searchResult.currentValue = str[0];
        this.searchResult = str[0];
      }, // 搜索查询结果限制
      center_change(val) {
        const _this = this;
        if (this.activeName === 'first') {
          if (val instanceof Array) {
            if (val.length === 0) return;
            val.map((obj) => {
              const val_obj = obj;
              const index = _this.r_result.findIndex((n) => {
                if (val_obj.ID === n.screen && _this.exclude === n.exclude) return true;
              });// 找到相同项
              if (index !== -1) return; // 说明已经存在了
              _this.r_result.unshift({
                screen_string: obj[this.code_name[0]], // 商品款号
                screen: obj.ID, // 商品ID
                exclude: _this.exclude, // 判断是否排除勾选项
                id_list: [obj.ID], // ID集合
              /* CONDITION: Object.keys(_this.l_screen_result_save).length === 0? 0 : _this.r_send_result.length - 1//表示是有筛选条件的下标 */
              /* ID: _this.r_result.length + '_choose',//ID
              checked: _this,//是否勾选 */
              });// 把筛选的值放入数组
            /* _this.r_result_checked.push(_this.r_result.length - 1 + '_choose');//使添加的直接勾选 */
            /* if(_this.exclude) {//筛选结果的排除项
              if(Object.keys(_this.l_screen_result_save).length === 0){
                _this.r_send_result[_this.r_send_result.length-1].ID.push(obj.ID);//没有筛选条件时的保存
              }else {
                _this.r_send_result[0].ID.push(obj.ID);//放入同一条件下的数组中
              }
            } */
            });
          } else {
            const index = _this.r_result.findIndex((n) => {
              if (val.ID === n.screen && _this.exclude === n.exclude) return true;
            });// 找到相同项
            if (index === -1) { // 没找到在添加
              this.r_result.unshift({
                screen_string: val[this.code_name[0]], // 商品款号
                screen: val.ID, // 商品ID
                exclude: this.exclude, // 判断是否排除勾选项
                id_list: [val.ID], // ID集合
              /* CONDITION: Object.keys(_this.l_screen_result_save).length === 0? 0 : _this.r_send_result.length - 1 //表示是有筛选条件的下标 */
              /* ID: this.r_result.length + '_choose',//ID
              checked: true,//是否勾选 */
              });// 把筛选的值放入数组
            } else { // 找到弹出提示已存在
              this.$message({
                message: t('该记录已在已选中列表中'),
                center: true,
                type: 'warning'
              });
            }
          /* if(_this.exclude) {//筛选结果的排除项
            if(Object.keys(_this.l_screen_result_save).length === 0){
              _this.r_send_result[_this.r_send_result.length-1].ID.push(val.ID);//没有筛选条件时的保存
            }else {
              _this.r_send_result[0].ID.push(val.ID);//放入同一条件下的数组中
            }
          } */
          /* this.r_result_checked.push(this.r_result.length - 1 + '_choose');//使添加的直接勾选 */
          }
          this.$refs.screen_ck.val_arr = [];// 清空选中的
          this.$refs.screen_ck.l_sub = [];// 清空高亮
          this.$refs.screen_ck.r_click_id = 0;// 清空shift高亮
          this.single_data = [];// 清空选中的
          this.right_request_center();
        } else {
          const index = _this.r_result.findIndex((n) => {
            if (val.ID === n.screen && n.exclude === true) return true;
          });// 找到相同项
          if (index === -1) { // 没找到在添加
            this.r_result.unshift({
              screen_string: val[this.code_name[0]], // 商品款号
              screen: val.ID, // 商品ID
              exclude: true, // 一定是排除项
              id_list: [val.ID], // ID集合
            /* ID: this.r_result.length + '_choose',//ID
            checked: true,//是否勾选 */
            });// 把筛选的值放入数组
          } else { // 找到提示已存在
            this.$message({
              message: t('该记录已在已选中列表中'),
              center: true,
              type: 'warning'
            });
          }
          this.onSearchResult();// 显示查询结果的数据
          this.request_total();// 查询查询条件的总数
        /* this.r_result_checked.push(this.r_result.length - 1 + '_choose');//使添加的直接勾选 */
        }
      }, // 将筛选结果勾选的集合或选中结果的排除项添加到右边列表
      /* 以上筛选结果和选中结果的公共事件 */

      right_dispose() {
        const _this = this;
        const CONDITION = []; const EXCLUDE = []; const IN = []; const 
          NOTIN = [];
        /* let CONDITION = [], EXCLUDE = [], IN = [], NOTIN = [], send_param = []; */
        /* this.r_send_result = this.r_send_result.map((obj) => {
        return {
          CONDITION: obj.CONDITION,
          ID: []
        }
      })//初始化有筛选条件的排除项
      console.log(this.r_result) */
        this.r_result.map((obj) => {
          if (obj.screen instanceof Object) { // 是对象说明是左边的节点树
            if (obj.exclude) { // 排除项
              EXCLUDE.push(obj.screen);
            } else { // 非排除项
              CONDITION.push(obj.screen);
            }
          /* Object.keys(obj.screen).map((tree_obj) => {//循环勾选的节点树
            let tree_val = tree_obj;
            if(obj.exclude) {//排除项
              if(!Object.keys(EXCLUDE).includes(tree_val))EXCLUDE[tree_val] = [];//查找是否有这个左边树的父节点
              EXCLUDE[tree_val].push(...obj.screen[tree_val]);
              EXCLUDE[tree_val] = [...new Set(EXCLUDE[tree_val].slice())]//去重
            }else {//非排除项
              if(!Object.keys(CONDITION).includes(tree_val))CONDITION[tree_val] = [];//查找是否有这个左边树的父节点
              /!*CONDITION[tree_val].push(...[...new Set(val.screen[tree_val])]);//去重*!/
              CONDITION[tree_val].push(...obj.screen[tree_val]);
              CONDITION[tree_val] = [...new Set(CONDITION[tree_val].slice())]//去重
            }
          }) */
          } else if (obj.exclude) { // 排除项
            NOTIN.push(obj.screen);
            /* if(Object.prototype.toString.call(obj.CONDITION) === '[object Undefined]'){//不是筛选条件的排除项
              NOTIN.push(obj.screen);
            }else {//有筛选条件的排除项
              if(this.r_send_result[obj.CONDITION].ID.includes(obj.screen))return//存在就不用添加了
              this.r_send_result[obj.CONDITION].ID.push(obj.screen);//放入对应的筛选条件下面
            } */
          } else { // 非排除项
            IN.push(obj.screen);
          }
        });
        /* this.r_result_checked.map((obj) => {
        let id = obj;//勾选项数组下标
        let val = _this.r_result.find((val,index,arr) => id === val.ID );//选出对应的勾选项
        if(!val) return ;
        if(val.screen instanceof Object) {//是对象说明是左边的节点树
          Object.keys(val.screen).map((tree_obj) => {//循环勾选的节点树
            let tree_val = tree_obj;
            if(val.exclude) {//排除项
              if(!Object.keys(EXCLUDE).includes(tree_val))EXCLUDE[tree_val] = [];//查找是否有这个左边树的父节点
              EXCLUDE[tree_val].push(...val.screen[tree_val]);
              EXCLUDE[tree_val] = [...new Set(EXCLUDE[tree_val].slice())]//去重
            }else {//非排除项
              if(!Object.keys(CONDITION).includes(tree_val))CONDITION[tree_val] = [];//查找是否有这个左边树的父节点
              /!*CONDITION[tree_val].push(...[...new Set(val.screen[tree_val])]);//去重*!/
              CONDITION[tree_val].push(...val.screen[tree_val]);
              CONDITION[tree_val] = [...new Set(CONDITION[tree_val].slice())]//去重
            }
          })
        }else {
          if(val.exclude) {//排除项
            NOTIN.push(val.screen)
          }else {//非排除项
            IN.push(val.screen)
          }
        }
      }); */
        /* this.r_send_result.map((obj) => {
        if(obj.ID.length === 0)return
        send_param.push(obj);
      }) */
        const param = {
          TABLENAME: this.tablename, // 表名
          CONDITION, // 各个父节点下面的勾选的子节点
          IN: [...[...new Set(IN)]], // 中间的勾选项
          NOTIN: [...[...new Set(NOTIN)]], // 中间的排除勾选项
          EXCLUDE, // 排除的各个父节点下面的勾选的子节点
          GLOBAL: this.searchResult.trim(), // 全局搜索值
          PAGENUM: this.r_center_data.r_currentPage, // 当前页
          PAGESIZE: this.r_center_data.r_page_size// 每页显示的个数
        };
        this.optimize_request = param;// 用于请求优化
        this.request_param = {
          TABLENAME: this.tablename, // 表名
          CONDITION, // 各个父节点下面的勾选的子节点
          IN: [...[...new Set(IN)]], // 中间的勾选项
          NOTIN: [...[...new Set(NOTIN)]], // 中间的排除勾选项
          EXCLUDE, // 排除的各个父节点下面的勾选的子节点
          GLOBAL: this.searchResult.trim(), // 全局搜索值
        };// 传给后台用的
        return param;
      }, // 右边列表的数据处理
      request_total() {
        this.request_param.GLOBAL = '';
        axios({
          url: '/p/cs/screenresultcheck',
          method: 'post',
          data: {
            param: JSON.stringify(this.request_param)
          }
        }).then((res) => {
          const response = res.data;
          if (response.code !== 0) {
            /* this.errorDialogClass = 'error';
          this.errorData = [{message: response.message}];
          this.errorDialog = true; */
            return;
          }
          this.r_center_data.rightTotal = response.data.total; // 选中结果总数
        });
      }, // 获取总数
      right_dispose_request() {
        this.confirmLoading = true;
        this.r_screenLoading = true;
        axios({
          url: '/p/cs/screenresultcheck',
          method: 'post',
          data: {
            param: JSON.stringify(this.optimize_request)
          }
        }).then((res) => {
          const response = res.data;
          this.confirmLoading = false;
          if (response.code !== 0) {
            /* this.errorDialogClass = 'error';
          this.errorData = [{message: response.message}];
          this.errorDialog = true; */
            return;
          }
          this.r_center_data.total = response.data.total; // 选中结果总数
          if (!this.searchResult.trim()) this.r_center_data.rightTotal = response.data.total; // 选中结果总数
          this.r_table_data.header = JSON.parse(response.header);// 头部信息
          this.r_table_data.body[this.r_center_data.r_currentPage - 1] = response.data.list; // body信息
          /* this.r_table_data.checked[this.r_center_data.r_currentPage-1] = []; //选中项保存 */
          this.r_screenLoading = false;
        });
      }, // 通过右边列表情况查询中间数据发起请求
      clearAllResult() {
        this.r_result = [];// 清空右边列表数据
        this.r_table_data.body = [];// 清空数据
        this.r_send_result = [
          {
            CONDITION: {},
            ID: []
          }
        ];// 初始化有筛选条件的排除项
        this.r_center_data.r_currentPage = 1;// 初始化当前页
        this.r_center_data.total = 0;
        this.right_dispose();// 只有每次点击second时在处理数据
        this.r_center_data.rightTotal = 0;// 查询选中结果条件总数清空
      /* this.right_request_center(); */
      }, // 清除右边所有条件并计算数据在请求
      deleteList(i) {
        this.r_result.splice(i, 1);// 删除这项
        if (this.r_result.length === 0) {
          this.r_table_data.body = [];// 清空数据
          this.r_center_data.r_currentPage = 1;// 初始化当前页
          this.r_center_data.total = 0;// 总条数
          this.right_dispose();// 只有每次点击second时在处理数据
          this.r_center_data.rightTotal = 0;// 查询选中结果条件总数清空
        } else {
          this.right_request_center();// 重新获取数据
        }
      }, // 删除选择项
      /* 以上右边列表相关事件 */

      r_handleSizeChange(val) {
        this.r_table_data.body = [];// 清空数据
        /* this.r_table_data.checked = [];//清空勾选项数据 */
        this.r_center_data.r_currentPage = 1;// 初始化当前页
        this.r_center_data.r_page_size = val;// 改变每页显示个数
        this.optimize_request.PAGENUM = 1;// 页码要变化
        this.optimize_request.PAGESIZE = val;// 每页显示个数变化
        this.right_dispose_request();// 获取数据
      }, // 页数变化发送数据不变化
      r_handleCurrentChange(val) {
        this.r_center_data.r_currentPage = val;// 初始化当前页
        if (this.r_table_data.body[this.r_center_data.r_currentPage - 1]) return;// 已存在数据就不用获取了
        this.optimize_request.PAGENUM = val;// 页码要变化
        this.right_dispose_request();// 获取数据
      }, // 当前页变化发送数据不变化
      onSearchResult() {
        if (this.r_result.length === 0 && !this.searchResult.trim()) return;
        this.optimize_request.GLOBAL = this.searchResult.trim();// 选中结果的筛选条件不变的
        this.r_table_data.body = [];// 清空数据
        this.r_center_data.r_currentPage = 1;// 初始化当前页
        this.right_dispose();// 只有每次点击second时在处理数据
        this.r_screenLoading = true;
        axios({
          url: '/p/cs/screenresultcheck',
          method: 'post',
          data: {
            param: JSON.stringify(this.optimize_request)
          }
        }).then((res) => {
          const response = res.data;
          if (response.code !== 0) {
            /* this.errorDialogClass = 'error';
          this.errorData = [{message: response.message}];
          this.errorDialog = true; */
            return;
          }
          this.r_center_data.total = response.data.total; // 筛选结果总数
          this.r_table_data.header = JSON.parse(response.header);// 头部信息
          this.r_table_data.body[this.r_center_data.r_currentPage - 1] = response.data.list; // body信息
          /* this.r_table_data.checked[this.r_center_data.r_currentPage-1] = []; //选中项保存 */
          this.r_screenLoading = false;
        });
      }, // 选中结果全局检索
      keyupSearch() {
        this.onSearchResult();
      }, // enter快捷
      /* querySearchAsync (queryString, cb) {
      this.right_dispose();//只有每次点击second时在处理数据
      axios({
        url: '/p/cs/screenresultcheck',
        method: 'post',
        params: {
          param: this.optimize_request
        }
      }).then((res) => {
        let response = res.data;
        if(response.code !== 0)return this.$message({
          message: response.message,
          center: true,
          type: 'error',
        });
        let restaurants = this.restaurants = response.data.list;
        let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      }).catch((res) => {
      })
    },//模糊搜索
    handleSelect (val) {

    },//模糊搜索选中项
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    }, */
      /* 以上选中结果的相关事件 */

      right_request_center() {
        this.r_table_data.body = [];// 清空数据
        /* this.$refs['result_ck'].r_click_sub = -1;//清除子组件的点击高亮 */
        /* this.r_table_data.checked = [];//清空勾选项数据 */
        this.r_center_data.r_currentPage = 1;// 初始化当前页
        this.right_dispose();// 只有每次点击second时在处理数据
        this.right_dispose_request();// 获取数据
      }, // 处理一遍发送数据并请求中间查看选中结果的数据
      /* tab切换成second时的事件 */

      result_save() {
        if (!this.module_name.trim()) {
          this.errorDialogClass = 'warning';
          this.errorData = [{ message: t('模板名称不能为空') }];
          this.errorDialog = true;
          return;
        }
        this.right_dispose();// 重新计算一遍
        this.request_param.GLOBAL = '';// 只传条件
        /* $.ajax({
        url:'/p/cs/setMultiQuery',
        type:'POST',
        dataType:'json',
        data:
          {
            tableid: this.tableid,
            modelname: this.module_name,
            multiQuery: {
              value: this.request_param,
              text: JSON.stringify({
                result: this.r_result,//渲染列表
                /!*condition: this.r_send_result//条件集合*!/
              })
            }
          }
        ,
        success:function(res){

        },
        error:function(){

        }
      }) */
        /* let postParam = new URLSearchParams();
      postParam.append('tableid', this.tableid);
      postParam.append('modelname', this.module_name);
      postParam.append('multiQuery', JSON.stringify({
        value: this.request_param,
        text: JSON.stringify({
          result: this.r_result,//渲染列表
          /!*condition: this.r_send_result//条件集合*!/
        })
      })); */
        axios({
          method: 'post',
          url: '/p/cs/setMultiQuery',
          data: {
            tableid: this.tableid,
            modelname: this.module_name,
            multiQuery: JSON.stringify({
              value: this.request_param,
              text: JSON.stringify({
                result: this.r_result, // 渲染列表
              /* condition: this.r_send_result//条件集合 */
              })
            })
          }
        })
      /* axios.post('/p/cs/setMultiQuery', postParam) */
      /* axios.post('/p/cs/setMultiQuery',
        qs.stringify({
          tableid: this.tableid,
          modelname: this.module_name,
          multiQuery: {
            value: this.request_param,
            text: JSON.stringify({
              result: this.r_result,//渲染列表
              /!*condition: this.r_send_result//条件集合*!/
            })
          }
        })
      ) */.then((res) => {
        const res_data = res.data;
        if (res_data.code !== 0) {
          /* this.errorDialogClass = 'error';
          this.errorData = [{message: res_data.message}];
          this.errorDialog = true; */
          return;
        }
        this.$message({
          message: t('保存成功'),
          center: true,
          type: 'success'
        });
        this.showOrHidden = false;// 关闭模板框
        });
      }, // 保存右边列表并发送给后台
      /* 以上时保存模板时的事件 */

      dialogClose() {
        $('.fkDialog .el-dialog__header .el-dialog__headerbtn').trigger('click');
        this.t_dialog_show = false;
        this.$emit('dialogClose');
      /* this.l_screen_result_save = {};//初始化
      this.request_param = {};//初始化 */
      }, // 关闭弹出框
      dialogConfirm() {
        $('.fkDialog .el-dialog__header .el-dialog__headerbtn').trigger('click');
        this.right_dispose();// 处理数据
        this.request_param.GLOBAL = '';// 只传条件
        // 判断是否只能选中一条数据
        if (this.isOneData && this.r_result.length > 1) {
          this.$message.warning(t('只能选取一条数据'));
          return;
        }
        if (true) {
          this.confirmLoading = true;
          axios({
            url: '/p/cs/screenresultcheck',
            method: 'post',
            data: {
              param: JSON.stringify(this.request_param)
            }
          }).then((res) => {
            const response = res.data;
            this.confirmLoading = false;
            if (response.code !== 0) {
              /* this.errorDialogClass = 'error';
            this.errorData = [{message: response.message}];
            this.errorDialog = true; */
              return;
            }
            if (response.ids.length > 8000) {
              return this.$message({
                message: t('查询数量已超过上限，请修改查询条件'),
                center: true,
                type: 'warning'
              });
            }
            this.$emit('easyData', JSON.stringify({
              value: this.request_param, // 传向后台的数据
              total: this.r_center_data.rightTotal, // 条数
              lists: {
                result: this.r_result, // 渲染列表
              /* condition: this.r_send_result//条件集合 */
              }, // 右边选中列表
              nameList: response.data.list, // name集合
              idArray: response.ids// 选中结果所有id
            }));
            this.t_dialog_show = false;
          });
        } else {
          this.$emit('easyData', JSON.stringify({
            value: this.request_param, // 传向后台的数据
            total: this.r_center_data.rightTotal, // 条数
            lists: {
              result: this.r_result, // 渲染列表
            /* condition: this.r_send_result//条件集合 */
            }, // 右边选中列表
            idArray: []
          }));
          this.t_dialog_show = false;
        }
      }, // 确认弹出框
      closeDialog() {
        this.t_dialog_show = false;
      },
      /* 以上关闭弹框并向父组件传递数据 */

      entry_page() {
        this.tree_loading = true;
        if (this.rightList instanceof Object) {
          if (Object.keys(this.rightList).length !== 0) {
            this.r_result = this.rightList.result.map(obj => obj);// 显示右边数据
          /* this.r_send_result = this.rightList.condition.map(obj => obj);//筛选条件 */
          }
        } else {
          const r_obj = JSON.parse(this.rightList);
          if (Object.prototype.toString.call(r_obj.lists) !== '[object Undefined]') {
            this.r_result = r_obj.lists.result;
          /* if(!!r_obj.lists.condition && r_obj.lists.condition.length !== 0) {
            this.r_send_result = r_obj.lists.condition;
          } */
          } else {
            /* console.log(r_obj.text) */
            const obj_result = JSON.parse(r_obj.text);
            this.r_result = obj_result.result.map(obj => obj);
          /* if(!!obj_result.condition && obj_result.condition.length !== 0) {
            this.r_send_result = obj_result.condition;
          } */
          }
        }
        /* this.r_result_checked = this.rightList.map((obj) => {
        if(obj.checked)return obj.ID
      });//勾选选中的 */
        axios({
          url: '/p/cs/screen',
          method: 'post',
          data: {
            param: JSON.stringify({
              TABLENAME: this.tablename
            })
          }
        }).then((res) => {
          const response = res.data;
          if (response.code !== 0) {
            /* this.errorDialogClass = 'error';
          this.errorData = [{message: response.message}];
          this.errorDialog = true; */
            return;
          }
          this.tree_lists = response.data.map((obj) => {
            obj.checked = [];
            obj.VALUE.forEach((n) => {
              n.ischecked = false;
            });
            obj.show = false;
            return obj;
          });
          this.tree_loading = false;
        /* this.$nextTick(()=> {
          this.nodeCLose();//默认收拢
        }) */
        });
        this.screen_request_initialize().then(() => {
          if (this.r_result.length !== 0) { // 先拿到配置的名字
            this.right_dispose();
            this.right_dispose_request();
          }
        });// 获取初始数据
      }, // 初始化
      errorDialogClose(value, option) {
        this.errorDialog = false;
      }, // 关闭弹框
    /* reaptData(obj) {   //深拷贝
      if(obj instanceof Array){   //array
          let temp = []
          obj.forEach((item,index) => {
              let temp2 = []
              if(item instanceof Array){
                  item.forEach((item2, index) => {
                      temp2.push(item2)
                  })
                  temp.push(temp2)

              }else{
                  temp.push(item)
              }

          })
          return temp
      }else{   //obj
          let temp = {}

          for(var item in obj){
              temp[item] = obj[item]
          }

          return temp
      }
    }, */
    /* checked_change (val) {
      console.log(val)
      if(this.activeName === 'first' ){
        this.l_table_data.checked[this.l_center_data.l_currentPage-1] = val;
      }else {
        this.r_table_data.checked[this.r_center_data.r_currentPage-1] = val;
      }
    },//中间复选框改变时 */
    /* r_result_change (val) {
      val.checked = !val.checked;
      this.right_request_center();
      /!*this.r_table_data.body = [];//清空数据
      this.r_table_data.checked = [];//清空勾选数据
      this.r_center_data.r_currentPage = 1;//初始化当前页
      this.right_dispose();//处理数据
      this.right_dispose_request();//获取数据*!/
    },//右边勾选框变化时处理数据并请求数据 */
    },
    watch: {
      /* exclude (val) {
      if( this.activeName === 'first') {//左边筛选条件列表树
        let screen={};
        this.l_table_data.body = [];//清空数据
        this.l_center_data.l_currentPage = 1;//页码重置
        if (val) {//排除勾选项
          this.tree_lists.map((obj) => {
            let checked_obj = obj;
            screen[obj['AKNAME']] = [];
            checked_obj['VALUE'].map((n_obj) => {
              let judge=checked_obj.checked.findIndex((n) => n_obj.ID === n );//查找列表中选中对象的下标
              if( judge === -1) {//选出没勾选的
                screen[checked_obj['AKNAME']].push(n_obj.ID);
              }
            })
          })
        }else { //不排除勾选项
          this.tree_lists.map((obj) => {
            screen[obj['AKNAME']] = obj.checked;
          })
        }
        this.l_screen_result_save = screen;//保存筛选结果
        this.screen_request();//获取筛选结果数据
      }else {//右边选中列表
        if (val) {//排除勾选项

        }
      }
    },//监听排除勾选的变化 */
      /* activeName (val) {
      if(val === 'second' && ){
        console.log(333333)
      }
    } */
      activeName(val) {
        if (val === 'second') {
          if (this.r_result_length !== this.r_result.length && this.r_result.length !== 0) { // 右边列表数据变化时在获取数据
            this.right_request_center();// 获取中间的数据
          }
        } else {
          this.r_result_length = this.r_result.length;
        }
      },
      t_dialog_show(val) {
        this.$emit('update:fkshow', val);// 关闭弹框
      },
      showOrHidden(a) {
        if (a) this.module_name = '';// 清空模板名
      }
    /* searchResult (val) {
      console.log(this.$refs['trigger_searchResult'].$refs.suggestions.showPopper)
      if(val.trim().length === 0) {
        this.$refs['trigger_searchResult'].$refs.suggestions.showPopper = false;
      }else {
        this.$refs['trigger_searchResult'].$refs.suggestions.showPopper = true;
      }
    } */
    },
    mounted() {
      this.entry_page();
      if (this.$route.params['0'] == 'table/SG_B_CHANNEL_PRODUCT') {
        const madel = document.documentElement.querySelector('.v-modal');
        madel.style.zIndex = 1998;
      }
    },

    created() {
      const _self = this;
      this.t_dialog_show = this.fkshow;
    }
  };
</script>
<style lang="less" type="text/less">
  .fk-error-dialog {
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    .fk-error-dialog-box {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 10px;
      width: 400px;
      height: 140px;
      overflow: hidden;
      margin: auto;
      .fk-error-dialog-title {
        line-height: 30px;
        text-align: center;
        position: relative;
        background-color: #f7b901;
        color: #fff;
        font-size: 13px;
        .fk-error-icon {
          position: absolute;
          width: 16px;
          height: 16px;
          right: 8px;
          .icon-cha1 {
            font-size: 18px;
            cursor: pointer;
          }
        }
      }
      .fk-error-dialog-body {
        height: 110px;
        background-color: #fff;
        box-sizing: border-box;
        align-items: center;
        padding: 20px;
        .fk-body-top {
          display: flex;
          .fk-body-top-left i{
            font-size: 30px;
            color: #f7b901;
          }
          .fk-body-top-right {
            margin-left: 10px;
            p {
              line-height: 20px;
            }
          }
        }
        .fk-body-bottom {
          margin-top: 10px;
          text-align: right;
          button {
            height: 24px;
            width: auto;
            margin-right: 8px;
            margin-left: 0px;
            padding: 0 8px;
            background: #fff;
            color: #fd6442;
            border: 1px solid #fd6442;
            border-radius: 2px;
            font-size: 12px;
            &:hover {
              border-color: rgba(253, 100, 66, .6);
              color: rgba(253, 100, 66, .6)
            }
          }
        }
      }
    }
  }
</style>
<style lang="less" type="text/less">
  .fkdialog {
    display: flex;
    /*min-width: 940px;*/
    width: 980px;
    > div {
      padding: 0 10px;
      box-sizing: border-box;
    }
    .dialog-operation {
      width: 30px;
      padding: 0;
      border-width: 0 1px;
      border-color: #d8d8d8;
      border-style: solid;
      background-color: #fff;
      position: relative;
      .operation-icon {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 20px;
        color: #FD6442;
        box-sizing: border-box;
        border: 1px solid;
        border-radius: 2px;
        cursor: pointer;
      }
      .operation-single {
        top: 260px;
      }
      .operation-more {
        top: 190px;
      }
      .operation-hover:hover {
        color: rgba(253, 100, 66, .6);
      }
      .icon-bc {
        background-color: #EBEBEB;
        color: #D8D8D8;
        border: none;
        cursor: not-allowed;
      }
    }
    .dialog_left {
      width: 170px;
      box-shadow: 2px -2px 9px #ececec;
      display: flex;
      flex-direction: column;
      height: 484px;
      .left_top {
        height: 30px;
        line-height: 30px;
        box-sizing: border-box;
        border-bottom: 1px solid #d8d8d8;
        font-size: 12px;
        color: #575757;

        > span:first-child {
          float: left;
        }

        > span:last-child {
          float: right;

          i {
            margin-right: 8px;
            font-size: 13px;
            color: #f00f0f;
            -webkit-text-stroke-width: 0;
            &:hover {
              opacity: .6;
              cursor: pointer;
            }
          }

          i:last-child {
            margin-right: 0;
          }
        }
      }

      .left_center {
        flex: 1;
        padding-top: 10px;
        height: 390px;
        padding-bottom: 10px;
        width: 156px;
      }
      .left-tree {
        height: 100%;
        overflow-y: auto;
      }
      .left_bottom {
        padding-top: 10px;
        padding-bottom: 10px;
        box-sizing: border-box;
        height: 44px;
        > button {
          height: 24px;
          padding: 0;
          width: 100%;
          font-size: 12px;
          color: #fd6442;
          border: 1px solid #fd6442;
          border-radius: 2px;
          &:hover {
            opacity: .6;
          }
        }
      }
    }

    .dialog_center {
      width: 560px;
      height: 484px;
      box-shadow: 2px -2px 9px #ececec;
      display: flex;
      flex-direction: column;
      .el-tab-auto {
        font-size: 12px;
        position: relative;
      }
      .el-tabs {
        flex: 1;
        .el-tabs__header {
          margin: 0;
          border-color: #d8d8d8;
          .el-tabs__nav {
            margin-left: 10px;
            .el-tabs__item {
              height: 30px;
              line-height: 30px;
              color: #575757;
              font-size: 12px;
            }
            .el-tabs__active-bar {
              background-color: #fd6442;
            }
          }
        }
      }
      .center_bottom {
        height: 33px;
        box-sizing: border-box;
        .el-input {
          float: left;
          font-size: 12px;
          width: 270px;
          .el-input-group__prepend {
            color: #575757;
            border-color: #d8d8d8;
            background-color: #fff;
            border-top-left-radius: 2px;
            border-bottom-left-radius: 2px;
          }
          input {
            height: 24px;
            color: #000;
            border: 1px solid #d8d8d8;
            width: 200px;
            border-top-right-radius: 2px;
            border-bottom-right-radius: 2px;
            padding: 3px 6px;
            &:hover, &:focus {
              border: 1px solid #0F8EE9;
            }
          }
          .el-input__icon {
            width: auto;
            margin-right: 6px;
          }
        }
        .center-exclude {
          float: left;
          height: 24px;
          line-height: 24px;
          margin-left: 10px;
          font-size: 12px;
          color: #575757;
        }
      }
    }
    .second-width {
      width: 590px;
    }
    .dialog_right {
      width: 220px;
      padding-right: 10px;
      display: flex;
      flex-direction: column;
      .right_top {
        height: 30px;
        line-height: 30px;
        box-sizing: border-box;
        border-bottom: 1px solid #d8d8d8;
        font-size: 12px;
        color: #575757;
        > span {
          vertical-align: middle;
          float: left;
        }
        > span:first-child {
          margin-right: 5px;
        }
        > span:nth-child(3) {
          color: #f00f0f;
        }
        > span:last-child {
          float: right;
          > i {
            color: #f00f0f;
            font-size: 13px;
            &:hover {
              opacity: .6;
              cursor: pointer;
            }
          }
          > i:first-child {
            margin-right: 8px;
          }
        }
      }
      .right_center {
        flex: 1;
        padding-top: 10px;
        ul {
          height: 390px;
          overflow: auto;
          li {
            margin-bottom: 4px;
            display: flex;
            align-items: center;
            background-color: #f8f8f8;
            border-radius: 2px;
            font-size: 12px;
            /*label {
              display: flex;
              align-items: center;
            }
            span {
              flex-basis: 12px;
              margin-top: 0;
            }*/
            i {
              flex-basis: 20px;
              font-size: 14px;
              cursor: pointer;
            }
            .icon-fork:before {
              content: '\e638';
            }
            .icon-fork:hover::before {
              content: '\e6b4';
              color: #fd6442;
            }
            p {
              flex: 1;
              line-height: 18px;
              margin-left: 4px;
              box-sizing: border-box;
              border-radius: 4px;
              padding: 4px 6px;
              color: #0F8EE9;
              word-wrap: break-word;
              word-break: break-all;
            }
          }
        }
      }
      .right_bottom {
        padding-top: 10px;
        padding-bottom: 10px;
        box-sizing: border-box;
        height: 44px;
        > button:last-child {
          background-color: #fd6442;
          border: 1px solid #fd6442;
          color: white;
          margin-right: 6px;
          &:hover {
            background-color: #e6502f;
            color: #f3cec5;
            border: 1px solid #e6502f;
          }
        }
        > button:first-child {
          &:hover {
            // background-color: #e6502f;
            // color: #f3cec5;
            opacity: .6;
          }
        }
        > button {
          float: right;
          padding: 0 8px;
          height: 24px;
          font-size: 12px;
          color: #fd6442;
          border: 1px solid #fd6442;
          border-radius: 2px;
        }
      }
    }
  }
</style>
<style lang="less" scoped type="text/less">
  .fkdialog {
    input[type=checkbox] {
      display: none;
    }
    .checked-box {
      display: inline-block;
      position: relative;
      width: 12px;
      height: 12px;
      box-sizing: border-box;
      border-radius: 2px;
      margin-top: -3px;
      color: #D8D8D8;
      border: 1px solid;
      transition: color .25s cubic-bezier(.71, -.46, .88, .6), background-color .25s cubic-bezier(.71, -.46, .29, 1.46);
      vertical-align: middle;
      &::after {
        display: inline-block;
        box-sizing: content-box;
        content: "";
        border: 1px solid #fff;
        border-left: 0;
        border-top: 0;
        height: 6px;
        left: 3px;
        position: absolute;
        top: 1px;
        transform: rotate(45deg) scaleX(0);
        width: 3px;
        transition: transform .25s cubic-bezier(.71, -.46, .88, .6);
        transform-origin: center;
      }
    }
    input[type=checkbox]:checked + .checked-box {
      color: #0F8EE9;
      background-color: #0F8EE9;
      &::after {
        transform: rotate(45deg) scaleX(1);
      }
    }

    /* 覆盖饿了么UI原有样式 */
    .el-pagination--small li.more::before {
      line-height: 14px;
    }
    .el-pagination--small .el-pager li,
    .el-pagination--small .el-pager li.btn-quicknext {
      height: 14px;
      line-height: 14px;
    }
  }
</style>
<style lang="less" type="text/less">
  .dialog-div {
    .el-dialog .el-dialog__header .el-dialog__close {
      color: #909399;
    }
    .el-dialog .el-dialog__body {
      padding: 0;
    }
    /*.center-b-t {
      position: relative;
      .center-icon {
        height: 24px;
        width: 12px;
        left: 252px;
        z-index: 999;
      }
    }*/
  }

  .fkdialog {
    font-size: 12px;

    .el-pagination {
      padding: 5px 0 !important;

      .el-select {
        line-height: 24px;

        .el-input {
          width: 81px;
          font-size: 12px;
        }

      }
      .el-pager li {
        height: 24px;
        line-height: 24px;
        min-width: 24px;
      }

      .el-pagination__editor {
        width: 45px;
        line-height: 24px;
        height: 24px;
      }

      .el-pager li.active {
        border-color: #d4dade;
        background-color: #d4dade;
      }

    }
    .el-pagination button, .el-pagination span {
      min-width: 24px;
      font-size: 12px;
      line-height: 24px;
      box-sizing: border-box;
      height: 24px;
    }

    .el-pagination .el-select .el-input .el-input__icon {
      width: 27px;
      height: 24px;
    }

    .el-pagination .el-select .el-input input {
      height: 24px;
    }

    .el-pagination__sizes .el-input .el-input__inner {
      padding: 3px;
      font-size: 12px;
    }

    .modalDiv {
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
      z-index: 100;
      position: absolute;
      top: 0;
      left: 0;
    }

    .modalCenter {
      width: 418px;
      height: 152px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -210px;
      margin-top: -71px;
      background-color: #fff;
      border: 1px solid #f8f7f7;
      border-radius: 12px;
      overflow: hidden;
    }

    .modalTitle {
      height: 28px;
      width: 100%;
      line-height: 28px;
      text-align: center;
      background-color: #f8f7f7;
      border-bottom: 1px solid #bcbcbc;
    }

    .modalTitle .icon-cha1 {
      width: 14px;
      height: 14px;
      font-size: 16px;
      position: absolute;
      /*top: 8px;*/
      right: 10px;
      cursor: pointer;
    }

    .modalContent .muBan {
      position: absolute;
      top: 39px;
      left: 50%;
      font-size: 28px;
      margin-left: -14px;
      display: block;
      width: 28px;
      height: 28px;
      color: #09A155;
    }

    .textCenter {
      margin: 48px 0 0 60px;
    }

    .textCenter input {
      border: 1px solid #d8d8d8;
      width: 228px;
      height: 22px;
      padding: 0 5px;
      border-radius: 2px;
      font-size: 12px;
      color: #575757;
    }

    .textCenter input:focus {
      border-color: #0f8ee9;
    }

    .modalBtn {
      position: absolute;
      bottom: 10px;
      right: 40px;
    }

    .modalBtn .btn {
      padding: 0 18px;
      width: 66px;
      height: 24px;
      box-sizing: border-box;
      background-color: #fff;
      border: 1px solid;
      color: #FD6442;
      font-size: 12px;
      border-radius: 2px;

      span {
        color: #FD6442;
      }

    }
    .modalBtn .btn:hover {
      background-color: rgba(253, 100, 66, .3);
      color: rgba(253, 100, 66, .6);
    }
  }
</style>
